/*
  /pages/brands — sections/shoes-egy-brands.liquid.

  - Tier buttons show all brands, Sport or Luxury.
  - Each brand row is a button; one brand is open at a time.
  - Opening a brand loads its pairs-per-model counts once, from
    sections/shoes-egy-brand-models.liquid rendered against the brand's
    collection, then orders its chips by count. A chip whose pairs are all
    unpublished goes. If the request fails the chips stay, without counts.
*/
(function () {
  document.querySelectorAll('[data-brands]').forEach(function (root) {
    var filters = root.querySelector('[data-brands-filters]');
    var loaded = {};

    // ------------------------------------------------------------- tiers
    if (filters) {
      filters.hidden = false;
      filters.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tier]');
        if (!btn) return;
        var tier = btn.getAttribute('data-tier');
        filters.querySelectorAll('[data-tier]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        root.querySelectorAll('[data-tier-group]').forEach(function (group) {
          group.hidden = tier !== 'all' && group.getAttribute('data-tier-group') !== tier;
        });
      });
    }

    // ------------------------------------------------------------- rows
    function setOpen(item, open) {
      var row = item.querySelector('[aria-controls]');
      var panel = document.getElementById(row.getAttribute('aria-controls'));
      row.setAttribute('aria-expanded', String(open));
      item.classList.toggle('is-open', open);
      panel.hidden = !open;
      if (open) loadCounts(panel);
    }

    root.addEventListener('click', function (e) {
      var row = e.target.closest('.shoes-brandx__row');
      if (!row || !root.contains(row)) return;
      var item = row.closest('[data-brand]');
      var opening = row.getAttribute('aria-expanded') !== 'true';
      root.querySelectorAll('[data-brand].is-open').forEach(function (other) {
        if (other !== item) setOpen(other, false);
      });
      setOpen(item, opening);
    });

    // ------------------------------------------------------------- counts
    function fetchPage(url, page) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      return fetch(url + sep + 'section_id=shoes-egy-brand-models&page=' + page)
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var data = doc.querySelector('[data-brand-models]');
          if (!data) throw new Error('no data');
          return JSON.parse(data.textContent);
        });
    }

    function loadCounts(panel) {
      var url = panel.getAttribute('data-models-url');
      var chips = panel.querySelectorAll('[data-tags]');
      if (!url || !chips.length || loaded[url]) return;
      loaded[url] = true;

      fetchPage(url, 1)
        .then(function (first) {
          var rest = [];
          for (var page = 2; page <= first.pages; page++) rest.push(fetchPage(url, page));
          return Promise.all(rest).then(function (more) {
            return more.reduce(function (all, d) { return all.concat(d.tags); }, first.tags);
          });
        })
        .then(function (tags) {
          var counts = {};
          tags.forEach(function (t) { counts[t] = (counts[t] || 0) + 1; });

          var list = chips[0].closest('ul');
          var items = Array.prototype.map.call(chips, function (chip) {
            var n = chip.getAttribute('data-tags').split(' ').reduce(function (sum, t) {
              return sum + (counts[t] || 0);
            }, 0);
            chip.querySelector('[data-count]').textContent = '(' + n + ')';
            return { li: chip.closest('li'), n: n, name: chip.textContent };
          });
          items
            .sort(function (a, b) { return b.n - a.n || a.name.localeCompare(b.name); })
            .forEach(function (it) {
              if (it.n === 0) it.li.remove();
              else list.appendChild(it.li);
            });
        })
        .catch(function () {
          loaded[url] = false; // try again next time the brand is opened
        });
    }

    root.querySelectorAll('[data-brand].is-open [data-models-url]').forEach(loadCounts);
  });
})();
